// CANONICAL COPY (GH #7115). src/constants/obligations/obl-incident-evidence.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-incident-evidence',
  title: 'Verify evidence collection and preservation procedures',
  description:
    'Confirm that procedures exist for the identification, collection, acquisition and preservation of information that can serve as evidence during and after a security incident. Verify that forensic readiness guidance is documented, chain-of-custody records are kept, and tooling is available to investigators.',
  category: 'incidents',
  scfIds: ['SCF-INC-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Evidence collection / forensic readiness procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
